import React, { useContext } from "react"
import { ModalM } from "../../../common/components/modal/ModalM"
import TextM from "../../../common/components/text/TextM"
import { theme } from "../../../common/theme/theme"
import { DimensionsContext } from "../../../common/utils/mobileUtils"
import { ChampionImageM } from "../../champions/ChampionImageM"
import TouchableRippleM from "@common/components/button/TouchableRippleM"

const ActivityDeletedModal = (props) => {
    const { onContinue, visible } = props

    const dimensions = useContext(DimensionsContext)

    const width = dimensions?.width > 800 ? "60%" : "90%"

    return (
        <ModalM
            visible={visible}
            dismissable={false}
            style={{
                width,
                alignItems: "center",
            }}
        >
            <ChampionImageM name="abou" variant="unhappy" width={100} />
            <TextM
                fontWeight="Bold"
                fontSize={22}
                color={theme.colors.primary}
                style={{
                    marginTop: 16,
                    marginBottom: 8,
                    textAlign: "center",
                }}
                wrap
            >
                Cette activité n'est plus disponible
            </TextM>
            <TextM
                fontSize={16}
                color={theme.colors.text}
                style={{ marginBottom: 16, textAlign: "center" }}
                wrap
            >
                Tu vas passer à la suivante automatiquement.
            </TextM>
            <TouchableRippleM
                autoClickDuration={5 * 1000}
                autoClickColor={theme.colors.primary}
                autoClickPaused={!visible}
                onPress={onContinue}
                style={{
                    width: width,
                    alignSelf: "center",
                    marginBottom: 20,
                    height: 50,
                    justifyContent: "center",
                    alignItems: "center",
                    borderRadius: 15,
                    elevation: 10,
                }}
            >
                <TextM color={theme.colors.white} fontWeight="ExtraBold" fontSize={16}>CONTINUER</TextM>
            </TouchableRippleM>
        </ModalM>
    )
}

export default ActivityDeletedModal
